var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pageLoading" }, [
      _c("span"),
      _c("span"),
      _c("span"),
      _c("div", { staticClass: "font" }, [_vm._v("LOADING...")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }